module.exports = __webpack_public_path__ + "img/bg_intro_footer.dbb70362.png";